module.exports = __webpack_public_path__ + "static/media/dental.fb30896b.jpg";